var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 142,
    viewBox: "0 0 230 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "coding"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1",
    x: 66,
    y: 44,
    width: 121,
    height: 69,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M177.445 43.4035H65.2566V38.9714C65.2569 37.6737 65.7725 36.4293 66.6901 35.5117C67.6077 34.5941 68.8522 34.0784 70.1498 34.0781H175.95C175.77 34.9572 175.679 35.8522 175.678 36.7496V36.8577H82.7998V40.586H176.152L176.242 40.5607C176.537 41.5496 176.941 42.5029 177.445 43.4035Z",
    fill: "#81F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M126.291 116.071C127.008 116.071 127.709 116.283 128.306 116.681C128.902 117.079 129.367 117.646 129.641 118.308C129.916 118.97 129.988 119.699 129.848 120.402C129.708 121.106 129.363 121.752 128.856 122.259C128.349 122.766 127.703 123.111 126.999 123.251C126.296 123.391 125.567 123.319 124.905 123.044C124.242 122.77 123.676 122.305 123.278 121.709C122.88 121.112 122.667 120.411 122.668 119.694C122.668 118.734 123.05 117.812 123.73 117.133C124.409 116.453 125.331 116.071 126.291 116.071Z",
    fill: "#FFD997"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M191.677 61.5875V103.332C190.817 103.702 189.98 104.125 189.172 104.597L187.283 103.958L187.331 103.812V53.6548L191.677 61.5875Z",
    fill: "#FFD997"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M191.677 53.0074V61.5875L187.331 53.6525V51.686C188.736 52.2579 190.191 52.7002 191.677 53.0074Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M183.275 126.304H175.349L179.051 113.087H181.486C180.847 114.672 180.519 116.364 180.517 118.072C180.54 121.039 181.506 123.922 183.275 126.304Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M179.055 113.087L175.353 126.303H67.5119C65.7612 126.303 64.0822 125.608 62.8443 124.37C61.6063 123.132 60.9109 121.453 60.9109 119.702V88.1775L65.2567 82.6265V108.193C65.257 109.491 65.7727 110.735 66.6903 111.653C67.6079 112.571 68.8523 113.086 70.15 113.087H179.055ZM129.924 119.694C129.924 118.977 129.711 118.276 129.313 117.68C128.915 117.083 128.349 116.619 127.687 116.344C127.024 116.069 126.295 115.997 125.592 116.137C124.888 116.276 124.242 116.621 123.735 117.128C123.228 117.635 122.882 118.281 122.742 118.984C122.601 119.687 122.673 120.416 122.947 121.079C123.221 121.742 123.685 122.308 124.281 122.707C124.877 123.106 125.578 123.319 126.295 123.319C127.257 123.319 128.178 122.937 128.858 122.257C129.538 121.577 129.92 120.656 129.92 119.694H129.924Z",
    fill: "#FFD997"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M177.493 55.6754C177.748 55.6691 178.002 55.714 178.24 55.8074C178.477 55.9008 178.694 56.0408 178.877 56.2191C179.06 56.3975 179.205 56.6106 179.304 56.846C179.403 57.0813 179.454 57.3342 179.454 57.5896C179.454 57.8449 179.403 58.0978 179.304 58.3331C179.205 58.5685 179.06 58.7816 178.877 58.96C178.694 59.1383 178.477 59.2783 178.24 59.3717C178.002 59.4651 177.748 59.51 177.493 59.5037H133.365C132.986 59.5045 132.615 59.3926 132.3 59.1825C131.985 58.9723 131.739 58.6733 131.594 58.3233C131.449 57.9733 131.412 57.5881 131.486 57.2166C131.56 56.8451 131.743 56.504 132.011 56.2366C132.188 56.0578 132.399 55.9161 132.632 55.8198C132.864 55.7234 133.113 55.6743 133.365 55.6754H177.493Z",
    fill: "#81F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M177.493 63.8608C178.001 63.8608 178.488 64.0626 178.847 64.4217C179.206 64.7807 179.408 65.2678 179.408 65.7756C179.408 66.2834 179.206 66.7704 178.847 67.1295C178.488 67.4886 178.001 67.6903 177.493 67.6903H111.039C110.531 67.6894 110.044 67.4871 109.685 67.1278C109.326 66.7684 109.124 66.2813 109.123 65.7733C109.125 65.2661 109.328 64.7804 109.687 64.4221C110.046 64.0638 110.532 63.8621 111.039 63.8608H177.493Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M177.493 72.0479C177.748 72.0417 178.002 72.0866 178.24 72.1799C178.478 72.2733 178.694 72.4133 178.877 72.5917C179.06 72.7701 179.205 72.9832 179.304 73.2185C179.404 73.4539 179.455 73.7067 179.455 73.9621C179.455 74.2175 179.404 74.4703 179.304 74.7057C179.205 74.941 179.06 75.1542 178.877 75.3325C178.694 75.5109 178.478 75.6509 178.24 75.7443C178.002 75.8377 177.748 75.8825 177.493 75.8763H155.691C155.183 75.876 154.696 75.674 154.337 75.3148C153.978 74.9556 153.776 74.4684 153.775 73.9604C153.776 73.4529 153.979 72.9664 154.338 72.6079C154.697 72.2493 155.184 72.0479 155.691 72.0479H177.493Z",
    fill: "#81F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M177.493 80.23C178.001 80.23 178.488 80.4317 178.847 80.7908C179.206 81.1499 179.408 81.6369 179.408 82.1447C179.408 82.6526 179.206 83.1396 178.847 83.4987C178.488 83.8578 178.001 84.0595 177.493 84.0595H107.319C106.811 84.0589 106.323 83.8567 105.964 83.4973C105.605 83.1379 105.402 82.6507 105.402 82.1424C105.404 81.6351 105.607 81.1492 105.966 80.7909C106.325 80.4325 106.812 80.2309 107.319 80.23H177.493Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M177.493 88.4204C177.992 88.4327 178.467 88.6397 178.816 88.9973C179.165 89.355 179.361 89.8349 179.361 90.3346C179.361 90.8343 179.165 91.3142 178.816 91.6718C178.467 92.0295 177.992 92.2365 177.493 92.2488H140.808C140.3 92.2485 139.813 92.0465 139.453 91.6873C139.094 91.3281 138.891 90.841 138.891 90.3329C138.892 89.8253 139.095 89.3391 139.454 88.9806C139.814 88.6222 140.3 88.4207 140.808 88.4204H177.493Z",
    fill: "#81F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M177.493 96.606C177.748 96.5998 178.002 96.6447 178.24 96.738C178.478 96.8314 178.694 96.9714 178.877 97.1498C179.06 97.3282 179.205 97.5413 179.304 97.7766C179.404 98.012 179.455 98.2648 179.455 98.5202C179.455 98.7756 179.404 99.0284 179.304 99.2638C179.205 99.4991 179.06 99.7123 178.877 99.8906C178.694 100.069 178.478 100.209 178.24 100.302C178.002 100.396 177.748 100.441 177.493 100.434H166.854C166.346 100.434 165.859 100.232 165.5 99.8729C165.141 99.5137 164.939 99.0265 164.938 98.5185C164.94 98.0111 165.142 97.5251 165.502 97.1666C165.861 96.8082 166.347 96.6066 166.854 96.606H177.493Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M177.493 104.792C178.001 104.792 178.488 104.993 178.847 105.352C179.206 105.711 179.408 106.198 179.408 106.706C179.408 107.214 179.206 107.701 178.847 108.06C178.488 108.419 178.001 108.621 177.493 108.621H118.482C117.974 108.62 117.486 108.418 117.127 108.059C116.768 107.699 116.566 107.212 116.565 106.704C116.567 106.197 116.77 105.711 117.129 105.352C117.488 104.994 117.975 104.792 118.482 104.792H177.493Z",
    fill: "#81F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M177.641 47.5032L175.785 51.3178H118.482C117.974 51.3178 117.487 51.1161 117.128 50.757C116.769 50.3979 116.567 49.9109 116.567 49.403C116.567 48.8952 116.769 48.4082 117.128 48.0491C117.487 47.69 117.974 47.4883 118.482 47.4883H177.493C177.545 47.4883 177.59 47.4998 177.641 47.5032Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M67.5119 30.9077H177.017C176.534 31.9174 176.176 32.9821 175.95 34.0783H70.15C68.8523 34.0786 67.6079 34.5942 66.6903 35.5118C65.7727 36.4294 65.257 37.6738 65.2567 38.9715V54.592C63.9085 53.593 62.4504 52.7515 60.9109 52.0838V37.5087C60.9109 35.758 61.6063 34.079 62.8443 32.8411C64.0822 31.6032 65.7612 30.9077 67.5119 30.9077Z",
    fill: "#FFD997"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M176.243 40.5609L176.153 40.5862H82.7996V36.8579H175.683C175.69 38.1128 175.878 39.3601 176.243 40.5609Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M156.285 96.606C156.785 96.6182 157.26 96.8252 157.609 97.1829C157.957 97.5405 158.153 98.0204 158.153 98.5201C158.153 99.0198 157.957 99.4997 157.609 99.8574C157.26 100.215 156.785 100.422 156.285 100.434H82.3883C81.8803 100.434 81.3931 100.232 81.0339 99.8728C80.6747 99.5136 80.4727 99.0264 80.4724 98.5184C80.4739 98.0111 80.6764 97.525 81.0355 97.1666C81.3945 96.8081 81.881 96.6066 82.3883 96.606H156.285Z",
    fill: "#81F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M145.121 72.0479C145.62 72.0601 146.095 72.2671 146.444 72.6248C146.793 72.9824 146.989 73.4623 146.989 73.962C146.989 74.4617 146.793 74.9416 146.444 75.2993C146.095 75.6569 145.62 75.864 145.121 75.8762H82.3883C81.8803 75.8759 81.3931 75.674 81.0339 75.3147C80.6747 74.9555 80.4727 74.4683 80.4724 73.9603C80.4733 73.4528 80.6756 72.9663 81.0348 72.6078C81.394 72.2492 81.8808 72.0479 82.3883 72.0479H145.121Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M140.547 135.796L142.118 142.72H139.9H113.637H110.47L114.191 126.304L140.547 135.796Z",
    fill: "#FFD997"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M138.397 126.304L140.547 135.796L114.192 126.304H138.397Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M130.236 88.4204C130.736 88.4327 131.211 88.6397 131.56 88.9973C131.909 89.355 132.104 89.8349 132.104 90.3346C132.104 90.8343 131.909 91.3142 131.56 91.6718C131.211 92.0295 130.736 92.2365 130.236 92.2488H82.3883C81.8803 92.2485 81.3931 92.0465 81.0339 91.6873C80.6747 91.328 80.4727 90.8409 80.4724 90.3329C80.4733 89.8253 80.6756 89.3389 81.0348 88.9803C81.394 88.6218 81.8808 88.4204 82.3883 88.4204H130.236Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M122.794 55.6754C123.05 55.6691 123.304 55.714 123.541 55.8074C123.779 55.9008 123.996 56.0408 124.179 56.2191C124.361 56.3975 124.507 56.6106 124.606 56.846C124.705 57.0813 124.756 57.3342 124.756 57.5896C124.756 57.8449 124.705 58.0978 124.606 58.3331C124.507 58.5685 124.361 58.7816 124.179 58.96C123.996 59.1383 123.779 59.2783 123.541 59.3717C123.304 59.4651 123.05 59.51 122.794 59.5037H82.3879C82.1326 59.51 81.8786 59.4651 81.6409 59.3717C81.4032 59.2783 81.1866 59.1383 81.0038 58.96C80.821 58.7816 80.6757 58.5685 80.5765 58.3331C80.4774 58.0978 80.4263 57.8449 80.4263 57.5896C80.4263 57.3342 80.4774 57.0813 80.5765 56.846C80.6757 56.6106 80.821 56.3975 81.0038 56.2191C81.1866 56.0408 81.4032 55.9008 81.6409 55.8074C81.8786 55.714 82.1326 55.6691 82.3879 55.6754H122.794Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M107.91 47.4883C108.418 47.4883 108.905 47.69 109.264 48.0491C109.623 48.4082 109.825 48.8952 109.825 49.403C109.825 49.9109 109.623 50.3979 109.264 50.757C108.905 51.1161 108.418 51.3178 107.91 51.3178H82.3883C81.8803 51.3175 81.3931 51.1155 81.0339 50.7563C80.6747 50.3971 80.4727 49.9099 80.4724 49.4019C80.4736 48.8943 80.6759 48.408 81.035 48.0493C81.3942 47.6906 81.8808 47.4889 82.3883 47.4883H107.91Z",
    fill: "#81F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M107.91 104.792C108.418 104.792 108.905 104.993 109.264 105.352C109.623 105.711 109.825 106.198 109.825 106.706C109.825 107.214 109.623 107.701 109.264 108.06C108.905 108.419 108.418 108.621 107.91 108.621H82.3883C81.8802 108.62 81.393 108.418 81.0338 108.059C80.6746 107.699 80.4727 107.212 80.4724 106.704C80.4739 106.197 80.6764 105.711 81.0355 105.352C81.3945 104.994 81.881 104.792 82.3883 104.792H107.91Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M100.469 63.8608C100.976 63.8608 101.463 64.0626 101.823 64.4217C102.182 64.7807 102.383 65.2678 102.383 65.7756C102.383 66.2834 102.182 66.7704 101.823 67.1295C101.463 67.4886 100.976 67.6903 100.469 67.6903H82.3883C81.8802 67.6897 81.393 67.4875 81.0338 67.1281C80.6746 66.7687 80.4727 66.2814 80.4724 65.7733C80.4739 65.2659 80.6764 64.7799 81.0355 64.4214C81.3945 64.063 81.881 63.8614 82.3883 63.8608H100.469Z",
    fill: "#81F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M96.7472 80.23C97.255 80.23 97.7421 80.4317 98.1011 80.7908C98.4602 81.1499 98.662 81.6369 98.662 82.1447C98.662 82.6526 98.4602 83.1396 98.1011 83.4987C97.7421 83.8578 97.255 84.0595 96.7472 84.0595H82.3883C81.8802 84.0589 81.393 83.8567 81.0338 83.4972C80.6746 83.1378 80.4727 82.6506 80.4724 82.1424C80.4739 81.6351 80.6764 81.149 81.0355 80.7906C81.3945 80.4322 81.881 80.2306 82.3883 80.23H96.7472Z",
    fill: "#81F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M71.739 64.4497C71.9913 64.5438 72.2115 64.7081 72.3736 64.9232C72.5357 65.1382 72.6329 65.3951 72.654 65.6635C72.675 65.932 72.6189 66.2009 72.4922 66.4386C72.3656 66.6762 72.1737 66.8727 71.9391 67.005V66.7635C71.9391 66.5738 71.9391 66.384 71.9242 66.1943V66.1494C71.8997 65.5794 71.8378 65.0116 71.739 64.4497Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M71.2327 47.9761C71.5149 47.9752 71.7911 48.058 72.0262 48.2142C72.2613 48.3703 72.4448 48.5927 72.5534 48.8532C72.662 49.1137 72.6909 49.4005 72.6364 49.6775C72.5819 49.9544 72.4465 50.2089 72.2472 50.4088C72.048 50.6087 71.7939 50.7449 71.5172 50.8003C71.2404 50.8557 70.9535 50.8278 70.6926 50.72C70.4318 50.6122 70.2088 50.4294 70.0519 50.1948C69.895 49.9602 69.8113 49.6843 69.8113 49.4021C69.8113 49.0247 69.9609 48.6627 70.2273 48.3954C70.4937 48.1281 70.8553 47.9773 71.2327 47.9761Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M71.2327 56.1626C71.5146 56.1619 71.7905 56.2449 72.0252 56.401C72.26 56.5572 72.4432 56.7795 72.5515 57.0398C72.6599 57.3001 72.6886 57.5867 72.634 57.8633C72.5794 58.1399 72.444 58.3941 72.2449 58.5937C72.0457 58.7934 71.7919 58.9294 71.5154 58.9847C71.2389 59.0399 70.9522 59.0119 70.6917 58.9042C70.4311 58.7964 70.2084 58.6138 70.0517 58.3794C69.8949 58.145 69.8113 57.8694 69.8113 57.5874C69.8113 57.2102 69.9609 56.8483 70.2274 56.5811C70.4939 56.314 70.8554 56.1635 71.2327 56.1626Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M71.233 72.5354C71.6109 72.5354 71.9733 72.6855 72.2405 72.9527C72.5077 73.2199 72.6578 73.5823 72.6578 73.9602C72.6578 74.3381 72.5077 74.7005 72.2405 74.9678C71.9733 75.235 71.6109 75.3851 71.233 75.3851C70.9292 75.3779 70.6355 75.2752 70.3935 75.0914C70.1515 74.9076 69.9737 74.6523 69.8852 74.3616L69.6897 74.2385C70.0256 73.7169 70.3275 73.1741 70.5936 72.6136L70.6569 72.6423C70.7753 72.525 71.1353 72.5354 71.233 72.5354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M71.2327 88.9067C71.5149 88.9058 71.7911 88.9887 72.0262 89.1448C72.2613 89.301 72.4448 89.5234 72.5534 89.7838C72.662 90.0443 72.6909 90.3312 72.6364 90.6081C72.5819 90.885 72.4465 91.1396 72.2472 91.3394C72.048 91.5393 71.7939 91.6756 71.5172 91.731C71.2404 91.7864 70.9535 91.7584 70.6926 91.6506C70.4318 91.5428 70.2088 91.3601 70.0519 91.1255C69.895 90.8909 69.8113 90.615 69.8113 90.3327C69.8113 89.9553 69.9609 89.5933 70.2273 89.326C70.4937 89.0587 70.8553 88.908 71.2327 88.9067Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M71.2327 97.0938C71.5146 97.0931 71.7905 97.1761 72.0252 97.3322C72.26 97.4884 72.4432 97.7106 72.5515 97.9709C72.6599 98.2312 72.6886 98.5178 72.634 98.7945C72.5794 99.0711 72.444 99.3253 72.2449 99.5249C72.0457 99.7245 71.7919 99.8606 71.5154 99.9158C71.2389 99.9711 70.9522 99.9431 70.6917 99.8353C70.4311 99.7276 70.2084 99.545 70.0517 99.3106C69.8949 99.0762 69.8113 98.8006 69.8113 98.5186C69.8113 98.1413 69.9609 97.7794 70.2274 97.5123C70.4939 97.2452 70.8554 97.0947 71.2327 97.0938Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M71.2327 105.279C71.515 105.278 71.7912 105.361 72.0263 105.517C72.2614 105.674 72.4449 105.896 72.5535 106.157C72.6621 106.417 72.6909 106.704 72.6364 106.981C72.5818 107.258 72.4462 107.513 72.2468 107.712C72.0475 107.912 71.7933 108.048 71.5165 108.104C71.2397 108.159 70.9527 108.131 70.6918 108.023C70.431 107.915 70.2081 107.732 70.0514 107.497C69.8946 107.262 69.8111 106.986 69.8113 106.704C69.8113 106.327 69.9609 105.965 70.2274 105.698C70.4939 105.431 70.8554 105.28 71.2327 105.279Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M63.2877 80.2368L65.3577 81.2155L65.2531 81.4386V82.6265L60.9072 88.1776V81.4386C61.7246 81.0872 62.5196 80.6859 63.2877 80.2368Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M56.2034 82.9683L56.2437 83.1511C54.3209 87.5119 51.8737 91.8394 49.0067 94.2475C48.076 95.0287 47.1805 95.8199 46.3203 96.6211C45.996 91.8658 45.6464 87.0542 45.3118 83.1511C46.9608 83.4513 48.6336 83.6018 50.3097 83.6008C52.2913 83.6037 54.2675 83.3916 56.2034 82.9683Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M42.7222 104.767C43.4296 103.11 44.5202 101.644 45.9043 100.491C46.1159 100.328 46.3275 100.163 46.5437 100.007C49.9583 97.6051 53.679 95.6713 57.6067 94.2568C57.502 94.4799 53.5058 102.945 49.6717 106.179C48.7827 106.926 47.8926 107.597 47.052 108.249C46.1988 108.898 45.3919 109.605 44.637 110.366C43.8036 111.187 43.1444 112.167 42.6989 113.248C42.2533 114.329 42.0304 115.489 42.0437 116.659V116.849H40.4038V116.659C40.4247 114.653 40.6116 112.653 40.9627 110.679C41.2973 108.642 41.8885 106.655 42.7222 104.767Z",
    fill: "#81F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M47.4587 116.658V116.848H45.4646C45.3676 114.668 45.0887 112.5 44.6309 110.366C45.3858 109.605 46.1927 108.897 47.0459 108.249C47.3023 112.566 47.4587 115.795 47.4587 116.658Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M46.5434 100.003C46.3272 100.163 46.1156 100.327 45.904 100.491C44.52 101.644 43.4294 103.109 42.722 104.766C42.2792 104.076 41.7318 103.312 41.0993 102.459C39.6296 100.472 37.7252 98.0537 35.7714 95.3662C33.4186 92.2151 31.3183 88.8832 29.4901 85.4014C29.4901 85.4014 29.4786 85.383 29.4602 85.3497C29.1853 84.8023 28.9243 84.2595 28.6759 83.7086C20.5373 65.7583 25.8101 47.8608 25.8101 47.8608C28.6002 50.4058 31.218 53.1335 33.6462 56.0258C32.1208 57.3753 30.8916 59.0263 30.0362 60.8746C29.1807 62.7228 28.7175 64.7283 28.6759 66.7645C28.6759 74.7237 35.7714 81.396 45.3118 83.152C45.6464 87.0551 45.996 91.8667 46.3203 96.622C46.3951 97.7559 46.4733 98.8863 46.5434 100.003Z",
    fill: "#81F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M40.1623 103.873C40.1623 103.873 40.7729 107.508 40.9673 110.675C40.6162 112.65 40.4292 114.65 40.4084 116.655V116.845H38.7742V116.655C39.3492 112.807 38.7593 108.476 38.7742 106.429C39.1886 105.552 39.652 104.699 40.1623 103.873Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M41.0995 102.46C40.7729 102.92 40.4601 103.393 40.1623 103.873C39.652 104.698 39.1886 105.552 38.7742 106.429C37.266 109.689 36.4731 113.235 36.4489 116.827V116.845H35.7934C35.7538 112.852 35.3414 108.871 34.5618 104.955C34.9378 102.986 35.1368 100.754 35.3771 98.476C35.4852 97.449 35.6002 96.4117 35.7417 95.3882L35.7716 95.3652C37.7254 98.0551 39.6298 100.47 41.0995 102.46Z",
    fill: "#81F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M35.7933 116.848H32.8953C32.7055 106.987 26.0378 103.873 19.3621 98.2472C12.4621 92.4386 5.28149 77.1045 5.28149 77.1045C12.459 79.6895 19.2416 83.2612 25.4341 87.7167C25.627 87.8801 25.8282 88.0337 26.0367 88.1767C30.8667 91.9648 33.3265 98.8119 34.5616 104.955C35.3415 108.873 35.7539 112.854 35.7933 116.848Z",
    fill: "#81F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M35.7715 95.3665L35.7416 95.3895C35.6001 96.413 35.4851 97.4503 35.377 98.4772C34.7146 94.0831 31.1945 91.7463 26.0379 88.1778C25.8366 88.0214 25.6388 87.865 25.4341 87.7178C20.7571 83.7963 19.2954 74.2295 19.2954 74.2295C24.6498 77.377 29.0589 84.6738 29.4603 85.3511C29.4787 85.3845 29.4902 85.4029 29.4902 85.4029C31.3184 88.8842 33.4187 92.2158 35.7715 95.3665Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M60.9109 81.4387C61.7271 81.0872 62.521 80.6859 63.2879 80.237L65.3579 81.2156L75.4779 85.9789L68.9229 75.3483C69.1978 74.9872 69.4588 74.6192 69.6969 74.2386C70.033 73.7167 70.335 73.1735 70.6008 72.6125C71.4472 70.8621 71.9039 68.949 71.9394 67.0051V66.7636C71.9394 66.5738 71.9394 66.3841 71.9244 66.1943",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M71.9284 66.1495C71.9024 65.5794 71.839 65.0116 71.7387 64.4498C70.92 60.4549 68.5996 56.9265 65.2561 54.592C63.9079 53.593 62.4498 52.7515 60.9103 52.0838C57.5637 50.64 53.9543 49.9054 50.3096 49.9264C44.1872 49.796 38.2394 51.9715 33.6461 56.0214C32.1207 57.3709 30.8915 59.0219 30.0361 60.8702C29.1806 62.7184 28.7174 64.7239 28.6758 66.7601C28.6758 74.7193 35.7713 81.3916 45.3117 83.1476C46.9607 83.4478 48.6335 83.5983 50.3096 83.5973C52.2913 83.6002 54.2674 83.3882 56.2033 82.9648C57.8184 82.6115 59.3949 82.1008 60.9103 81.4399",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M177.645 47.5034L178.702 45.3311C178.233 44.7205 177.81 44.0763 177.437 43.4037C176.934 42.5029 176.533 41.5496 176.239 40.5609C175.875 39.36 175.687 38.1127 175.681 36.8579V36.7498C175.68 35.8525 175.77 34.9575 175.95 34.0783C176.175 32.9822 176.532 31.9176 177.015 30.9078C180.065 24.4862 188.002 19.9092 197.312 19.9092C209.256 19.9092 218.942 27.4474 218.942 36.7498C218.942 46.0521 209.256 53.5881 197.312 53.5881C195.418 53.5912 193.53 53.3954 191.677 53.0039C190.191 52.6995 188.736 52.2583 187.331 51.686C186.3 51.2707 185.301 50.7806 184.341 50.2197L174.221 54.5368L175.792 51.3168L177.652 47.5023",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M187.283 103.959L180.812 101.767L183.54 109.488C182.693 110.588 182.002 111.799 181.486 113.087C180.847 114.671 180.519 116.364 180.517 118.072C180.541 121.039 181.507 123.922 183.277 126.304C186.979 131.438 194.046 134.91 202.153 134.91C214.098 134.91 223.784 127.371 223.784 118.072C223.784 108.773 214.098 101.235 202.153 101.235C198.555 101.216 194.991 101.932 191.679 103.337C190.819 103.707 189.983 104.129 189.175 104.602L187.283 103.959Z",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M60.9109 52.0838V37.5087C60.9109 35.758 61.6063 34.079 62.8443 32.8411C64.0822 31.6032 65.7612 30.9077 67.5119 30.9077H177.017",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M114.195 126.303H67.5119C65.7612 126.303 64.0822 125.608 62.8443 124.37C61.6063 123.132 60.9109 121.453 60.9109 119.702V81.4385",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M183.275 126.304H175.35H138.397",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M191.677 53.0073V61.5875V103.337",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M65.2566 54.5964V38.9714C65.2569 37.6737 65.7725 36.4293 66.6901 35.5117C67.6077 34.5941 68.8522 34.0784 70.1498 34.0781H175.95",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M181.486 113.086H70.1498C68.8522 113.086 67.6077 112.571 66.6901 111.653C65.7725 110.735 65.2569 109.491 65.2566 108.193V81.4385",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M187.331 51.6904V53.6546V103.813",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M65.2566 43.4033H177.44",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M176.153 40.5862H82.801V36.8579H175.651",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M129.92 119.694C129.92 120.412 129.708 121.113 129.31 121.709C128.912 122.306 128.346 122.771 127.683 123.046C127.021 123.321 126.292 123.393 125.589 123.253C124.885 123.114 124.239 122.769 123.731 122.262C123.224 121.756 122.878 121.11 122.738 120.406C122.597 119.703 122.669 118.974 122.943 118.311C123.217 117.649 123.681 117.082 124.277 116.683C124.873 116.284 125.574 116.071 126.291 116.071C127.253 116.07 128.175 116.452 128.856 117.132C129.536 117.811 129.919 118.733 129.92 119.694Z",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M110.47 142.72L114.191 126.304H138.397L140.547 135.796L142.118 142.72",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M114.192 126.304L140.547 135.796",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    d: "M75.6157 41.0183L79.4222 38.823L75.6157 36.623",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    d: "M73.1557 36.623L69.3457 38.823L73.1557 41.0183",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    d: "M187.331 53.6548L191.677 61.5875",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    d: "M179.051 113.087L175.349 126.304",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_63",
    d: "M65.2567 82.6265L60.9109 88.1775",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_64",
    d: "M46.7484 142.72H33.7994C31.741 142.72 29.7669 141.902 28.3113 140.446C26.8558 138.991 26.0381 137.017 26.0381 134.958V116.848H54.5098V134.958C54.5095 137.017 53.6917 138.991 52.2362 140.446C50.7807 141.902 48.8068 142.719 46.7484 142.72Z",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_65",
    d: "M35.7933 116.848C35.7539 112.854 35.3415 108.873 34.5616 104.955C33.3265 98.8119 30.8667 91.9602 26.0378 88.1767C25.8366 88.0203 25.6388 87.8639 25.4341 87.7167C19.2416 83.2612 12.459 79.6895 5.28149 77.1045C5.28149 77.1045 12.4632 92.4386 19.3621 98.2472C26.0378 103.873 32.7021 106.987 32.8953 116.848",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_66",
    d: "M38.7743 106.433C37.266 109.693 36.4732 113.238 36.449 116.83",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_67",
    d: "M41.0992 102.459C40.7726 102.919 40.4598 103.393 40.162 103.873C39.6518 104.698 39.1883 105.552 38.7739 106.429",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_68",
    d: "M56.2439 83.1509C54.3211 87.5117 51.8739 91.8391 49.007 94.2472C48.0762 95.0285 47.1808 95.8197 46.3206 96.6208",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_69",
    d: "M34.5618 104.955C34.9378 102.986 35.1368 100.754 35.3771 98.4759C35.4852 97.449 35.6002 96.4117 35.7417 95.3882",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_70",
    d: "M57.615 94.2476C57.5069 94.4776 53.5107 102.939 49.68 106.173C48.7911 106.921 47.901 107.591 47.0603 108.243C46.2072 108.892 45.4003 109.599 44.6453 110.36C43.812 111.181 43.1528 112.161 42.7072 113.242C42.2616 114.324 42.0388 115.484 42.0521 116.653",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_71",
    d: "M46.5437 100.003C49.9583 97.6012 53.679 95.6674 57.6067 94.2529",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_72",
    d: "M40.4038 116.658C40.4247 114.653 40.6116 112.653 40.9627 110.678C41.2976 108.642 41.8888 106.657 42.7222 104.77C43.4296 103.113 44.5202 101.647 45.9043 100.494C46.1159 100.331 46.3275 100.166 46.5437 100.01",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_73",
    d: "M44.6309 110.366C45.0887 112.5 45.3676 114.668 45.4646 116.848",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_74",
    d: "M29.4905 85.4053C31.3187 88.887 33.419 92.2189 35.7718 95.37C37.7268 98.0576 39.63 100.476 41.0997 102.463C41.7322 103.315 42.2796 104.085 42.7224 104.77",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_75",
    d: "M33.6462 56.0249C31.218 53.1325 28.6002 50.4048 25.8101 47.8599C25.8101 47.8599 20.5373 65.7573 28.6759 83.7077C28.9243 84.2585 29.1853 84.8013 29.4602 85.3487",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_76",
    d: "M46.5434 100.01C46.4733 98.8898 46.3951 97.7593 46.3203 96.6243C45.996 91.869 45.6464 87.0574 45.3118 83.1543",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_77",
    d: "M47.4592 116.658C47.4592 115.795 47.3028 112.566 47.0498 108.249",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_78",
    d: "M29.4902 85.4048C29.4902 85.4048 29.4787 85.3864 29.4603 85.3531C29.0589 84.6757 24.6498 77.379 19.2954 74.2314C19.2954 74.2314 20.7571 83.7983 25.4341 87.7198C25.6272 87.8835 25.8288 88.0371 26.0379 88.1798C31.1945 91.7448 34.7146 94.085 35.377 98.4792",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_79",
    d: "M38.7742 106.429C38.7593 108.476 39.3492 112.807 38.7742 116.655",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_80",
    d: "M40.1621 103.873C40.1621 103.873 40.7728 107.508 40.9671 110.675",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_81",
    d: "M77.5176 46.0635V108.993",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_82",
    d: "M107.91 51.3178H82.3883C81.8803 51.3175 81.3931 51.1155 81.0339 50.7563C80.6747 50.3971 80.4727 49.9099 80.4724 49.4019C80.4736 48.8943 80.6759 48.408 81.035 48.0493C81.3942 47.6906 81.8808 47.4889 82.3883 47.4883H107.91C108.418 47.4883 108.905 47.69 109.264 48.0491C109.623 48.4082 109.825 48.8952 109.825 49.403C109.825 49.9109 109.623 50.3979 109.264 50.757C108.905 51.1161 108.418 51.3178 107.91 51.3178Z",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_83",
    d: "M177.645 47.5032C177.59 47.5032 177.545 47.4883 177.493 47.4883H118.482C117.974 47.4883 117.487 47.69 117.128 48.0491C116.769 48.4082 116.567 48.8952 116.567 49.403C116.567 49.9109 116.769 50.3979 117.128 50.757C117.487 51.1161 117.974 51.3178 118.482 51.3178H175.785L177.645 47.5032Z",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_84",
    d: "M72.6579 49.4021C72.6575 49.6835 72.5736 49.9585 72.417 50.1923C72.2603 50.4261 72.0379 50.6082 71.7777 50.7157C71.5176 50.8231 71.2315 50.851 70.9555 50.7959C70.6795 50.7408 70.4261 50.6052 70.2271 50.4061C70.0282 50.207 69.8928 49.9534 69.8379 49.6774C69.783 49.4014 69.8112 49.1153 69.9188 48.8552C70.0265 48.5952 70.2088 48.3729 70.4427 48.2164C70.6766 48.0599 70.9517 47.9763 71.2331 47.9761C71.4204 47.9758 71.6059 48.0125 71.779 48.084C71.9521 48.1556 72.1093 48.2606 72.2417 48.3931C72.3741 48.5256 72.479 48.683 72.5504 48.8561C72.6219 49.0292 72.6584 49.2148 72.6579 49.4021Z",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_85",
    d: "M122.794 59.5037H82.3879C82.1326 59.51 81.8786 59.4651 81.6409 59.3717C81.4032 59.2783 81.1866 59.1383 81.0038 58.96C80.821 58.7816 80.6757 58.5685 80.5765 58.3331C80.4774 58.0978 80.4263 57.8449 80.4263 57.5896C80.4263 57.3342 80.4774 57.0813 80.5765 56.846C80.6757 56.6106 80.821 56.3975 81.0038 56.2191C81.1866 56.0408 81.4032 55.9008 81.6409 55.8074C81.8786 55.714 82.1326 55.6691 82.3879 55.6754H122.794C123.05 55.6691 123.304 55.714 123.541 55.8074C123.779 55.9008 123.996 56.0408 124.179 56.2191C124.361 56.3975 124.507 56.6106 124.606 56.846C124.705 57.0813 124.756 57.3342 124.756 57.5896C124.756 57.8449 124.705 58.0978 124.606 58.3331C124.507 58.5685 124.361 58.7816 124.179 58.96C123.996 59.1383 123.779 59.2783 123.541 59.3717C123.304 59.4651 123.05 59.51 122.794 59.5037Z",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_86",
    d: "M177.493 59.5037H133.365C132.986 59.5045 132.615 59.3926 132.3 59.1825C131.985 58.9723 131.739 58.6733 131.594 58.3233C131.449 57.9733 131.412 57.5881 131.486 57.2166C131.56 56.8451 131.743 56.504 132.011 56.2366C132.188 56.0578 132.399 55.9161 132.632 55.8198C132.864 55.7234 133.113 55.6743 133.365 55.6754H177.493C177.748 55.6691 178.002 55.714 178.24 55.8074C178.477 55.9008 178.694 56.0408 178.877 56.2191C179.06 56.3975 179.205 56.6106 179.304 56.846C179.403 57.0813 179.454 57.3342 179.454 57.5896C179.454 57.8449 179.403 58.0978 179.304 58.3331C179.205 58.5685 179.06 58.7816 178.877 58.96C178.694 59.1383 178.477 59.2783 178.24 59.3717C178.002 59.4651 177.748 59.51 177.493 59.5037Z",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_87",
    d: "M72.6579 57.5874C72.6577 57.8689 72.5741 58.144 72.4175 58.378C72.261 58.6119 72.0386 58.7942 71.7785 58.9018C71.5184 59.0095 71.2323 59.0375 70.9562 58.9826C70.6802 58.9276 70.4266 58.792 70.2275 58.593C70.0285 58.394 69.8929 58.1404 69.838 57.8643C69.783 57.5883 69.8111 57.3021 69.9187 57.042C70.0263 56.7819 70.2086 56.5595 70.4426 56.403C70.6765 56.2465 70.9516 56.1628 71.2331 56.1626C71.4203 56.1623 71.6057 56.1989 71.7787 56.2704C71.9517 56.3419 72.1089 56.4469 72.2413 56.5792C72.3737 56.7116 72.4786 56.8688 72.5501 57.0418C72.6216 57.2148 72.6583 57.4002 72.6579 57.5874Z",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_88",
    d: "M100.469 67.6952H82.3883C81.8802 67.6946 81.393 67.4924 81.0338 67.133C80.6746 66.7736 80.4727 66.2863 80.4724 65.7782C80.4739 65.2708 80.6764 64.7847 81.0355 64.4263C81.3945 64.0679 81.881 63.8663 82.3883 63.8657H100.469C100.976 63.8657 101.463 64.0675 101.823 64.4265C102.182 64.7856 102.383 65.2727 102.383 65.7805C102.383 66.2883 102.182 66.7753 101.823 67.1344C101.463 67.4935 100.976 67.6952 100.469 67.6952Z",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_89",
    d: "M177.493 67.6952H111.039C110.531 67.6943 110.044 67.492 109.685 67.1326C109.326 66.7733 109.124 66.2862 109.123 65.7782C109.125 65.271 109.328 64.7853 109.687 64.427C110.046 64.0687 110.532 63.8669 111.039 63.8657H177.493C178.001 63.8657 178.488 64.0675 178.847 64.4265C179.206 64.7856 179.408 65.2727 179.408 65.7805C179.408 66.2883 179.206 66.7753 178.847 67.1344C178.488 67.4935 178.001 67.6952 177.493 67.6952Z",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_90",
    d: "M71.9437 66.7635C71.9437 66.8452 71.9437 66.9268 71.9357 67.005C72.1703 66.8727 72.3622 66.6762 72.4888 66.4386C72.6155 66.2009 72.6716 65.932 72.6505 65.6635C72.6295 65.3951 72.5322 65.1382 72.3701 64.9232C72.208 64.7081 71.9879 64.5438 71.7356 64.4497H71.7275C71.8294 65.0131 71.8954 65.5823 71.9253 66.154V66.2C71.9391 66.384 71.9437 66.5738 71.9437 66.7635Z",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_91",
    d: "M145.121 75.8762H82.3883C81.8803 75.8759 81.3931 75.674 81.0339 75.3147C80.6747 74.9555 80.4727 74.4683 80.4724 73.9603C80.4733 73.4528 80.6756 72.9663 81.0348 72.6078C81.394 72.2492 81.8808 72.0479 82.3883 72.0479H145.121C145.62 72.0601 146.095 72.2671 146.444 72.6248C146.793 72.9824 146.989 73.4623 146.989 73.962C146.989 74.4617 146.793 74.9416 146.444 75.2993C146.095 75.6569 145.62 75.864 145.121 75.8762Z",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_92",
    d: "M177.493 75.8763H155.691C155.183 75.876 154.696 75.674 154.337 75.3148C153.978 74.9556 153.776 74.4684 153.775 73.9604C153.776 73.4529 153.979 72.9664 154.338 72.6079C154.697 72.2493 155.184 72.0479 155.691 72.0479H177.493C177.748 72.0417 178.002 72.0866 178.24 72.1799C178.478 72.2733 178.694 72.4133 178.877 72.5917C179.06 72.7701 179.205 72.9832 179.304 73.2185C179.404 73.4539 179.455 73.7067 179.455 73.9621C179.455 74.2175 179.404 74.4703 179.304 74.7057C179.205 74.941 179.06 75.1542 178.877 75.3325C178.694 75.5109 178.478 75.6509 178.24 75.7443C178.002 75.8377 177.748 75.8825 177.493 75.8763Z",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_93",
    d: "M70.6595 72.6398C70.7745 72.5248 71.1356 72.5328 71.2345 72.5328C71.6124 72.5328 71.9748 72.683 72.242 72.9502C72.5093 73.2174 72.6594 73.5798 72.6594 73.9577C72.6594 74.3356 72.5093 74.698 72.242 74.9652C71.9748 75.2324 71.6124 75.3825 71.2345 75.3825C70.9308 75.3754 70.637 75.2726 70.395 75.0888C70.153 74.9051 69.9752 74.6497 69.8867 74.359",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_94",
    d: "M96.7472 84.0629H82.3883C81.8802 84.0623 81.393 83.8601 81.0338 83.5007C80.6746 83.1412 80.4727 82.654 80.4724 82.1458C80.4739 81.6385 80.6764 81.1524 81.0355 80.794C81.3945 80.4356 81.881 80.234 82.3883 80.2334H96.7472C97.255 80.2334 97.7421 80.4351 98.1011 80.7942C98.4602 81.1533 98.662 81.6403 98.662 82.1481C98.662 82.656 98.4602 83.143 98.1011 83.5021C97.7421 83.8612 97.255 84.0629 96.7472 84.0629Z",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_95",
    d: "M177.493 84.0629H107.319C106.811 84.0623 106.323 83.8601 105.964 83.5007C105.605 83.1413 105.402 82.6541 105.402 82.1458C105.404 81.6385 105.607 81.1526 105.966 80.7943C106.325 80.4359 106.812 80.2343 107.319 80.2334H177.493C178.001 80.2334 178.488 80.4351 178.847 80.7942C179.206 81.1533 179.408 81.6403 179.408 82.1481C179.408 82.656 179.206 83.143 178.847 83.5021C178.488 83.8612 178.001 84.0629 177.493 84.0629Z",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_96",
    d: "M130.236 92.2488H82.3883C81.8803 92.2485 81.3931 92.0465 81.0339 91.6873C80.6747 91.328 80.4727 90.8409 80.4724 90.3329C80.4733 89.8253 80.6756 89.3389 81.0348 88.9803C81.394 88.6218 81.8808 88.4204 82.3883 88.4204H130.236C130.736 88.4327 131.211 88.6397 131.56 88.9973C131.909 89.355 132.104 89.8349 132.104 90.3346C132.104 90.8343 131.909 91.3142 131.56 91.6718C131.211 92.0295 130.736 92.2365 130.236 92.2488Z",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_97",
    d: "M177.493 92.2488H140.808C140.3 92.2485 139.813 92.0465 139.453 91.6873C139.094 91.3281 138.891 90.841 138.891 90.3329C138.892 89.8253 139.095 89.3391 139.454 88.9806C139.814 88.6222 140.3 88.4207 140.808 88.4204H177.493C177.992 88.4327 178.467 88.6397 178.816 88.9973C179.165 89.355 179.361 89.8349 179.361 90.3346C179.361 90.8343 179.165 91.3142 178.816 91.6718C178.467 92.0295 177.992 92.2365 177.493 92.2488Z",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_98",
    d: "M72.6579 90.3327C72.6575 90.6142 72.5736 90.8892 72.417 91.123C72.2603 91.3568 72.0379 91.5389 71.7777 91.6463C71.5176 91.7538 71.2315 91.7817 70.9555 91.7266C70.6795 91.6715 70.4261 91.5358 70.2271 91.3367C70.0282 91.1377 69.8928 90.8841 69.8379 90.6081C69.783 90.332 69.8112 90.0459 69.9188 89.7859C70.0265 89.5258 70.2088 89.3035 70.4427 89.1471C70.6766 88.9906 70.9517 88.907 71.2331 88.9067C71.4204 88.9064 71.6059 88.9431 71.779 89.0147C71.9521 89.0863 72.1093 89.1913 72.2417 89.3238C72.3741 89.4563 72.479 89.6136 72.5504 89.7868C72.6219 89.9599 72.6584 90.1454 72.6579 90.3327Z",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_99",
    d: "M156.285 100.434H82.3883C81.8803 100.434 81.3931 100.232 81.0339 99.8728C80.6747 99.5136 80.4727 99.0264 80.4724 98.5184C80.4739 98.0111 80.6764 97.525 81.0355 97.1666C81.3945 96.8081 81.881 96.6066 82.3883 96.606H156.285C156.785 96.6182 157.26 96.8252 157.609 97.1829C157.958 97.5405 158.153 98.0204 158.153 98.5201C158.153 99.0198 157.958 99.4997 157.609 99.8574C157.26 100.215 156.785 100.422 156.285 100.434Z",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_100",
    d: "M177.493 100.434H166.854C166.346 100.434 165.859 100.232 165.5 99.8729C165.141 99.5137 164.939 99.0265 164.938 98.5185C164.94 98.0111 165.142 97.5251 165.502 97.1666C165.861 96.8082 166.347 96.6066 166.854 96.606H177.493C177.748 96.5998 178.002 96.6447 178.24 96.738C178.478 96.8314 178.694 96.9714 178.877 97.1498C179.06 97.3282 179.205 97.5413 179.304 97.7766C179.404 98.012 179.455 98.2648 179.455 98.5202C179.455 98.7756 179.404 99.0284 179.304 99.2638C179.205 99.4991 179.06 99.7123 178.877 99.8906C178.694 100.069 178.478 100.209 178.24 100.302C178.002 100.396 177.748 100.441 177.493 100.434Z",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_101",
    d: "M72.6579 98.5152C72.6577 98.7967 72.5741 99.0718 72.4175 99.3057C72.261 99.5397 72.0386 99.722 71.7785 99.8296C71.5184 99.9372 71.2323 99.9653 70.9562 99.9103C70.6802 99.8554 70.4266 99.7198 70.2275 99.5207C70.0285 99.3217 69.8929 99.0681 69.838 98.7921C69.783 98.516 69.8111 98.2298 69.9187 97.9697C70.0263 97.7096 70.2086 97.4873 70.4426 97.3308C70.6765 97.1742 70.9516 97.0906 71.2331 97.0903C71.4203 97.09 71.6057 97.1267 71.7787 97.1982C71.9517 97.2697 72.1089 97.3746 72.2413 97.507C72.3737 97.6394 72.4786 97.7965 72.5501 97.9696C72.6216 98.1426 72.6583 98.328 72.6579 98.5152Z",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_102",
    d: "M107.91 108.621H82.3883C81.8802 108.62 81.393 108.418 81.0338 108.059C80.6746 107.699 80.4727 107.212 80.4724 106.704C80.4739 106.197 80.6764 105.711 81.0355 105.352C81.3945 104.994 81.881 104.792 82.3883 104.792H107.91C108.418 104.792 108.905 104.993 109.264 105.352C109.623 105.711 109.825 106.198 109.825 106.706C109.825 107.214 109.623 107.701 109.264 108.06C108.905 108.419 108.418 108.621 107.91 108.621Z",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_103",
    d: "M177.493 108.621H118.482C117.974 108.62 117.486 108.418 117.127 108.059C116.768 107.699 116.566 107.212 116.565 106.704C116.567 106.197 116.77 105.711 117.129 105.352C117.488 104.994 117.975 104.792 118.482 104.792H177.493C178.001 104.792 178.488 104.993 178.847 105.352C179.206 105.711 179.408 106.198 179.408 106.706C179.408 107.214 179.206 107.701 178.847 108.06C178.488 108.419 178.001 108.621 177.493 108.621Z",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_104",
    d: "M72.6579 106.704C72.6577 106.986 72.5741 107.261 72.4175 107.495C72.261 107.729 72.0386 107.911 71.7785 108.019C71.5184 108.126 71.2323 108.154 70.9562 108.099C70.6802 108.044 70.4266 107.909 70.2275 107.71C70.0285 107.511 69.8929 107.257 69.838 106.981C69.783 106.705 69.8111 106.419 69.9187 106.159C70.0263 105.899 70.2086 105.676 70.4426 105.52C70.6765 105.363 70.9516 105.28 71.2331 105.279C71.4203 105.279 71.6056 105.316 71.7785 105.387C71.9515 105.459 72.1086 105.564 72.241 105.696C72.3733 105.829 72.4782 105.986 72.5498 106.159C72.6213 106.332 72.6581 106.517 72.6579 106.704Z",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_105",
    d: "M45.6617 66.6739H45.5283H45.3903C44.0088 66.6034 42.7095 65.9959 41.7695 64.981C40.8295 63.9661 40.3233 62.6242 40.3587 61.2413C40.3941 59.8584 40.9684 58.5441 41.959 57.5787C42.9497 56.6132 44.2784 56.073 45.6617 56.0732",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_106",
    d: "M38.1301 66.667H45.6615H45.5281C44.1373 66.7076 42.8181 67.2931 41.855 68.2973C40.8918 69.3015 40.3619 70.6439 40.3794 72.0352C40.3969 73.4265 40.9604 74.7552 41.9485 75.7349C42.9366 76.7146 44.2701 77.2667 45.6615 77.2723",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_107",
    d: "M55.1841 66.6739H55.3221H55.4555C56.837 66.6034 58.1363 65.9959 59.0763 64.981C60.0162 63.9661 60.5225 62.6242 60.4871 61.2413C60.4517 59.8584 59.8774 58.5441 58.8867 57.5787C57.8961 56.6132 56.5674 56.073 55.1841 56.0732",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_108",
    d: "M62.7154 66.667H55.1841H55.3221C56.7132 66.7077 58.0326 67.2936 58.9957 68.2983C59.9587 69.303 60.4883 70.6459 60.4702 72.0375C60.4521 73.4291 59.8877 74.7579 58.8989 75.7371C57.91 76.7164 56.5758 77.2678 55.1841 77.2723",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_109",
    d: "M201.88 42.9528L211.99 37.1188L201.88 31.2803",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_110",
    d: "M191.502 31.2803L181.392 37.1188L191.502 42.9528",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_111",
    d: "M199.57 28.6421L193.526 45.5091",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_112",
    d: "M190.621 125.016L192.258 120.044L196.143 108.249L200.031 120.044L201.669 125.016",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_113",
    d: "M192.258 120.044H200.03",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_114",
    d: "M210.081 122.121C209.013 124.409 207.015 125.738 205.623 125.09C204.232 124.443 203.972 122.058 205.039 119.766C206.106 117.474 208.101 116.149 209.496 116.796C209.925 117.06 210.27 117.44 210.49 117.893C210.711 118.346 210.797 118.852 210.74 119.352C210.722 120.312 210.497 121.256 210.081 122.121Z",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_115",
    d: "M210.736 119.318V119.352C210.941 121.365 209.709 126.668 212.921 124.509",
    stroke: "black",
    strokeWidth: 0.980065,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoding);
export default __webpack_public_path__ + "static/media/coding.2462cfd07f112720b7b2eec3e5352ab4.svg";
export { ForwardRef as ReactComponent };